import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { FilterListSingleComponent } from './filter-list-single.component';

@Component({
  selector: 'filter-option-advanced-number',
  templateUrl: './filter-option-advanced-number.component.html',
  styleUrls: ['./filter-option-advanced-number.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterOptionAdvancedNumberComponent<Name extends string> {
  @Input()
  name: Name;

  @Input()
  numberName: Name;

  @Input()
  optional: Boolean;

  readonly selected = this.filterListComponent.selected.pipe(
    map(selected => selected === this.name),
    distinctUntilChanged(),
  );

  constructor(
    private readonly filterListComponent: FilterListSingleComponent<string>,
  ) {}
}
